/** Kartalarning chap chetidagi chiziq — har biri o'z rangida. */
export const CARD_ACCENTS = [
  '#4FC3F7',
  '#F5821F',
  '#66DC7E',
  '#A185FD',
  '#437DFC',
  '#F5BD1E',
  '#44D6B4',
  '#E0518E',
];

/** Hududlar kesimidagi chiziqlar — yuqoridan pastga navbat bilan. */
export const BREAKDOWN_BAR_COLORS = [
  'bg-[#F5821F]',
  'bg-[#90CD22]',
  'bg-[#3EB5D7]',
  'bg-[#8655FD]',
  'bg-[#44BA82]',
  'bg-[#F5BD1E]',
  'bg-[#E0518E]',
  'bg-[#437DFC]',
  'bg-[#66DC7E]',
  'bg-[#A185FD]',
];

/** Ekin turlari halqasi. */
export const PLANT_COLORS = [
  '#44D6B4',
  '#437DFC',
  '#8655FD',
  '#F5821F',
  '#F5BD1E',
];

/** Oylik dinamika chizig'i. */
export const MONTHLY_CHART_COLOR = '#F5821F';
